import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDateTime(date: string | Date): string {
  const d = typeof date === "string" ? new Date(date) : date;
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");
  return `${day}.${month}.${year} u ${hours}:${minutes}`;
}

export function formatDate(date: string | Date): string {
  const d = typeof date === "string" ? new Date(date) : date;
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
}

export function formatCurrency(value: number, suffix = ""): string {
  const formatted = new Intl.NumberFormat("bs-BA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
  return suffix ? `${formatted} ${suffix}` : formatted;
}

// Brojevi (komadi, zaliha, dnevna prodaja) u bs-BA formatu: tačka kao separator
// hiljada. Isti formatter koriste i kartice i tabele, da 12500 nigdje ne ispadne „12500".
const numberFormats = new Map<number, Intl.NumberFormat>();
export function formatNumber(value: number, maximumFractionDigits = 0): string {
  let fmt = numberFormats.get(maximumFractionDigits);
  if (!fmt) {
    fmt = new Intl.NumberFormat("bs-BA", { maximumFractionDigits });
    numberFormats.set(maximumFractionDigits, fmt);
  }
  return fmt.format(value);
}

// Bosanska množina ima tri oblika: 1 pošiljka, 2-4 pošiljke, 5+ pošiljki.
// Bez ovoga svaki brojač ispadne "2 pošiljki".
export function plural(n: number, one: string, few: string, many: string): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}

export function calcDelta(current: number, previous: number): number | null {
  if (previous === 0) return current > 0 ? 100 : null;
  return ((current - previous) / Math.abs(previous)) * 100;
}

export function safeErrorMessage(e: any): string {
  if (e && typeof e === "object" && "message" in e) return e.message;
  return "Interna greška servera";
}

// Opens a blob (e.g. generated PDF) in a new tab. window.open() after an await
// is treated as a non-user-initiated popup and silently blocked, so fall back
// to an anchor click (and finally a download) when that happens.
export function openBlob(blob: Blob, filename = "dokument.pdf") {
  const url = URL.createObjectURL(blob);
  const win = window.open(url, "_blank");
  if (!win) {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener";
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
